import logo_voetmax from "../assets/voetmax2.png";
import logo_footcare from "../assets/logo.png";
import logo_care from "../assets/care_new_logo.png";
import logo_fittr from "../assets/fittr_logo.png";

export function getRuntimeConfig() {
	const version = process.env.VUE_APP_VERSION;
	const organisation = process.env.VUE_APP_ORGANISATION || "fittr";
	const test = process.env.VUE_APP_TEST === "true";

	const themeConfig = {
		fittr: {
			app_logo: logo_fittr,
			shareUrl: "https://fittrapp.com/osb/models",
			redirectUrl: "https://fittrapp.com",
			url: "https://fittrapp.com",
		},
		footcare: {
			app_logo: logo_footcare,
			shareUrl: test
				? "https://test-app.footcaremaatschoenen.info/osb/models"
				: "https://footcaremaatschoenen.info/osb/models",
			redirectUrl: test
				? "https://test-app.footcaremaatschoenen.info"
				: "https://footcaremaatschoenen.info",
			url: "https://footcare.nl",
		},
		voetmax: {
			app_logo: logo_voetmax,
			shareUrl: "https://app.voetmax.nl/osb/models",
			redirectUrl: "https://app.voetmax.nl",
			url: "https://app.voetmax.nl",
		},
		care: {
			app_logo: logo_care,
			shareUrl: "https://careorthopedieapp.nl/osb/models",
			redirectUrl: "https://careorthopedieapp.nl",
			url: "https://careorthopedieapp.nl",
		},
	};

	const config = themeConfig[organisation] || themeConfig.fittr;

	return {
		version,
		organisation,
		test,
		app_logo: config.app_logo || logo_fittr,
		shareUrl: config.shareUrl,
		redirectUrl: config.redirectUrl,
		url: config.url,
	};
}
